import { ScreenCompanyOccupancyColors } from '@dms/screen'

export default ScreenCompanyOccupancyColors
